import axios from 'axios';
import Config from '../config/config';

const defineEnv = Config;
const axiosInstance = axios.create({
  baseURL: defineEnv.payment_services.BASE_URL,
  headers: { 'X-FLPMX-Auth-Token': defineEnv.payment_services.token },
});

export default axiosInstance;
